// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"b10d2b9c","456":"2c46f381","656":"04b05f42","756":"9c9cc88d","787":"e70a0f79","968":"f252423a"}[chunkId] + ".chunk.js";
};